
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import machines from '~/images/about-us.png';
import machinery_movement from '~/images/the-used-machinery-movement.png';
import Image from 'next/image';
import Map from '@/components/visualization/GoogleMaps';
import CoorpLayout, {
  Title,
  Text,
  SubTitle,
} from '@/components/layout/CoorpLayout';
import { gtagContactEvent } from '@/lib/utilities/analytics/gtm';

export default function AboutUsPage() {
  const { t } = useTranslation('products');

  const locations = [
    {
      country: t('products:GERMANY_COUNTRY_NAME'),
      addresses: [
        {
          office: t('products:ADDRESS_HEADQUARTER'),
          address: [
            'GINDUMAC GmbH',
            'Trippstadter Strasse 110',
            '67663 Kaiserslautern',
            t('products:GERMANY_COUNTRY_NAME'),
          ],
          placeMap: 'Trippstadter+Strasse+110+67663+Kaiserslautern',
          phone: '+49 631 343738 20',
          email: t('products:HEADER_SUPPORT_CONTACT_WITH_US_EMAIL'),
          lat: 49.432311,
          lng: 7.753681,
        },
      ],
    },
    {
      country: t('products:SPAIN_COUNTRY_NAME'),
      addresses: [
        {
          office: t('products:ADDRESS_COUNTRY'),
          address: [
            'GINDUMAC S.L.U.',
            'Carrer de Pallars 84-88, 2º 2a',
            '08018 Barcelona',
            t('products:SPAIN_COUNTRY_NAME'),
          ],
          placeMap: 'Carrer+de+Pallars+84+08018+Barcelona',
          phone: '+34 932 207 165',
          email: 'contacto@gindumac.es',
          lat: 41.394833,
          lng: 2.189613,
        },
        {
          office: t('products:ADDRESS_REGIONAL'),
          address: [
            'GINDUMAC S.L.U.',
            'C/Sierra de Andia',
            '01010 Vitoria-Gasteiz',
            t('products:SPAIN_COUNTRY_NAME'),
          ],
          placeMap: 'Calle+Sierra+de+Andia+01010+Vitoria-Gasteiz',
          phone: '+34 601 158 008',
          email: 'contacto@gindumac.es',
          lat: 42.864409,
          lng: -2.690322,
        },
      ],
    },
  ];
  return (
    <CoorpLayout
      headingOne={t('products:CORPORATE_WHO_WE_ARE_H1')}
      headingTwo={'Global Industrial Machinery Cluster'}
      headingThree={t('products:CORPORATE_WHO_WE_ARE_H3_HERO')}
      breadcrubPages={[
        { name: t('products:HEADER_ABOUT_GINDUMAC') },
        { name: t('products:CORPORATE_WHO_WE_ARE'), href: '/who-we-are' },
      ]}
    >
      <Title title={t('products:CORPORATE_WHO_WE_ARE_TITLE_1')} />
      <Text text={t('products:CORPORATE_WHO_WE_ARE_P1')} />
      <Text text={t('products:CORPORATE_WHO_WE_ARE_P2')} />
      <Text text={t('products:CORPORATE_WHO_WE_ARE_P3')} />
      <div className=' mb-6 flex w-full items-center justify-center'>
        <Image
          src={machines}
          alt={'Example of used industrial machines to buy and sell'}
          className='mx-auto w-full object-cover object-center'
        />
      </div>
      <Title title={t('products:CORPORATE_WHO_WE_ARE_TITLE_2')} />
      <Text text={t('products:CORPORATE_WHO_WE_ARE_P4')} />
      <div className='mt-12' />
      <Title title={t('products:CORPORATE_WHO_WE_ARE_TITLE_3')} />
      <Text text={t('products:ABOUT_P1')} />
      <div className='mx-center flex w-full items-center justify-center pb-16 pt-8'>
        <Image
          src={machinery_movement}
          alt='The used machinery movement'
          className='mx-auto mt-4 w-full object-center pb-8'
        />
      </div>
      <Title title={t('products:ABOUT_H2_OFFICES')} />
      <Text text={t('products:ABOUT_P1_OFFICES')} />
      {locations.map((location, index) => {
        return (
          <div key={index} className='mt-12'>
            <SubTitle title={location.country} />
            {location.addresses.map((address, addressIndex) => {
              return <AddressSection key={addressIndex} location={address} />;
            })}
          </div>
        );
      })}
      <div className='mb-12' />
      <Title title={t('products:ABOUT_H2_TEAM')} />
      <Text text={t('products:ABOUT_P1_TEAM')} />
      <Text text={t('products:TEXT_MIDDLE_MANAGEMENT_TEAM')} />
      <Members />
    </CoorpLayout>
  );
}

function Members() {
  const ourTeamMembers = [
    {
      name: 'Daniel Kaiser',
      position: 'Co-CEO / Managing Partner',
      email: 'd.kaiser@gindumac.com',
      imageUrl: `/images/Daniel.png`,
    },
    {
      name: 'Benedikt Ruf',
      position: 'Co-CEO / Managing Partner',
      email: 'b.ruf@gindumac.com',
      imageUrl: `/images/Benedikt.png`,
    },
    {
      name: 'Borja Garcia Lomba',
      position: 'Head of Inventory & Pricing',
      email: 'b.garcia@gindumac.com',
      imageUrl: `${process.env.NEXT_PUBLIC_CDN_URL}images/platform_images/who_we_are/middle-management-team/borja-garcia.png`,
    },
  ];
  return (
    <div className='my-12'>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'>
        {ourTeamMembers.map((member) => (
          <div
            className={`flex flex-col items-center justify-start space-y-4 `}
            key={member.name}
          >
            <div className='relative h-40 w-40 overflow-hidden rounded-full border-4 border-brand-800'>
              <Image
                src={member.imageUrl}
                alt={member.name}
                fill
                sizes='152px'
                className='object-cover'
              />
            </div>
            <div className='flex flex-col items-center justify-center'>
              <p className='text-center'>
                <strong>{member.name}</strong>
              </p>
              <p className='text-center'>{member.position}</p>
              <a
                href={`mailto:${member.email}`}
                className='text-blue-500'
                onClick={gtagContactEvent}
              >
                {member.email}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

interface Address {
  office: string;
  email: string;
  phone: string;
  address: string[];
  placeMap: string;
  lat: number;
  lng: number;
}
function AddressSection({ location }: { location: Address }) {
  return (
    <div className='mx-auto mb-8 flex max-w-3xl flex-col lg:flex-row'>
      <div className='flex flex-col lg:w-1/2'>
        <ul className='pb-4 text-center lg:pb-0 lg:text-left'>
          <li>
            <strong>{location.office}</strong>
          </li>
          {location.address.map((address, index) => {
            return <li key={index}>{address}</li>;
          })}
          <li>
            <a href={`tel:${location.phone}`} className='text-blue-500'>
              T: {location.phone}
            </a>
          </li>
          <li>
            <a
              href={`mailto:${location.email}`}
              className='text-blue-500'
              onClick={gtagContactEvent}
            >
              E: {location.email}
            </a>
          </li>
        </ul>
      </div>
      <div className='flex flex-col lg:w-1/2'>
        <Map hasMarker lat={location.lat} lng={location.lng} />
      </div>
    </div>
  );
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/who-we-are/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  